<div class="lum-c-multiple-confirmation-dialog">
  <h2 mat-dialog-title>{{ data.title }}</h2>
  <mat-dialog-content
    class="lum-c-multiple-confirmation-dialog__container"
    [ngClass]="{ 'no-see-more': displayedValues.length < 5 }"
  >
    <div class="lum-c-multiple-confirmation-dialog__list">
      <div
        *ngFor="let value of displayedValues; trackBy: trackByValue"
        class="lum-c-multiple-confirmation-dialog__item"
      >
        {{ value }}
      </div>
    </div>

    <!-- Centered "See More" link -->
    <div
      *ngIf="!seeMore && data.values.length > 5"
      class="lum-c-multiple-confirmation-dialog__see-more"
    >
      <a
        (click)="expandDialog()"
        class="lum-c-multiple-confirmation-dialog__see-more-link"
      >
        See more...
      </a>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="lum-c-multiple-confirmation-dialog__actions">
    <!-- Cancel or Show Less Button -->
    <button
      class="lum-button lum-button--secondary lum-button--medium mx-1"
      mat-button
      color="primary"
      [ngClass]="{ 'w-20': !seeMore, 'w-25': seeMore }"
      (click)="onCancelOrShowLess()"
    >
      {{ seeMore ? 'Show Less' : 'Cancel' }}
    </button>
    <button
      mat-button
      class="lum-button lum-button--medium w-20 lum-button--delete"
      (click)="onConfirm()"
    >
      Delete
    </button>
  </mat-dialog-actions>
</div>
